import React from 'react';
import { FadeIn } from './FadeIn';
export function ProblemSection() {
  return <section className="py-16 sm:py-24 px-4 bg-pump-surface relative" data-id="element-165">
      <div className="max-w-3xl mx-auto" data-id="element-166">
        <FadeIn data-id="element-167">
          <div className="prose prose-invert prose-lg sm:prose-xl max-w-none" data-id="element-168">
            <p className="text-gray-300 leading-relaxed mb-6" data-id="element-169">
              Hay algo que ningún instructor de BodyPump dice en voz alta pero
              que casi todos sienten.
            </p>
            <p className="text-gray-300 leading-relaxed mb-6" data-id="element-170">
              No es que no saben dar una clase.
            </p>
            <p className="text-gray-300 leading-relaxed mb-6" data-id="element-171">
              No es que no les apasiona el escenario.
            </p>
            <p className="text-gray-300 leading-relaxed mb-8" data-id="element-172">
              Es algo más incómodo que eso.
            </p>

            <div className="bg-pump-dark border-l-4 border-pump-gold p-6 sm:p-8 rounded-r-xl mb-10 shadow-lg" data-id="element-173">
              <p className="text-white font-medium leading-relaxed mb-4" data-id="element-174">
                Es la sensación de que después de años de releases, de
                certificaciones, de horas en el podio y alumnos que vuelven cada
                semana, todavía llegás a la clase con la misma pregunta de
                siempre:
              </p>
              <p className="text-2xl sm:text-3xl font-display font-bold text-pump-gold mt-6" data-id="element-175">
                ¿Por qué mi sala no está llena todavía?
              </p>
            </div>

            <p className="text-gray-300 leading-relaxed mb-6" data-id="element-176">
              Y ahí empieza el ciclo. Mirás lo que hace el instructor de al
              lado. Copiás algo que viste en Instagram. Intentás ser más
              enérgico. Más técnico. Más simpático. Y nada termina de funcionar
              del todo. El tiempo que debería ser tuyo se convierte en otra
              semana de improvisación que nadie ve y que no te lleva a ningún
              lado.
            </p>

            <p className="text-gray-300 leading-relaxed font-bold mb-12" data-id="element-177">
              Incluyendo vos.
            </p>

            <div className="text-center mb-12" data-id="element-178">
              <h2 className="text-3xl sm:text-4xl font-display font-bold text-white mb-4" data-id="element-179">
                El problema no es tu técnica ni tu energía.
                <br className="hidden sm:block" data-id="element-180" />
                <span className="text-pump-gold" data-id="element-181">
                  {' '}
                  Es que nadie te enseñó el sistema completo.
                </span>
              </h2>
              <p className="text-gray-400 mb-6" data-id="element-182">
                Te formaste para dar clases de calidad. No para ser también:
              </p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 mb-12" data-id="element-183">
              {['Artista del escenario', 'Narrador emocional', 'Estratega de fidelización', 'Experto en marketing personal', 'Líder de comunidad', 'Diseñador de experiencias'].map((role, i) => <div key={i} className="bg-pump-dark border border-pump-muted p-4 rounded-lg text-center flex items-center justify-center" data-id="element-184">
                  <span className="font-medium text-gray-200" data-id="element-185">{role}</span>
                </div>)}
            </div>

            <p className="text-gray-300 leading-relaxed mb-6" data-id="element-186">
              Pero eso es exactamente lo que te pide la realidad de ser
              instructor de BodyPump hoy.
            </p>
            <p className="text-gray-300 leading-relaxed mb-6" data-id="element-187">
              Y sin un sistema que sostenga todo eso, el resultado es siempre el
              mismo:{' '}
              <strong className="text-white" data-id="element-188">
                salas a medio llenar, alumnos que no fidelizan y la sensación
                permanente de que trabajás más de lo que cosechás.
              </strong>
            </p>
            <p className="text-gray-300 leading-relaxed" data-id="element-189">
              No es falta de pasión. No es falta de talento. Es que estás
              haciendo el trabajo de seis roles distintos sin las herramientas
              para ninguno de los seis.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}